<div class="mt-20 bg-white radius-10">
  <div class="p-20 flex content-between" style="border-bottom: solid 1px #F0F5FF;">
    <div class="flex gap-10 align-items-center mb-5">
      <img src="assets/square-icon.svg" alt="">
      <div>
        <p class="no-margin light-blue bold">Composition du bureau de vote</p>
        <p class="no-margin dark-gray">Le bureau de vote supervise et valide les étapes du scrutin électronique.</p>
      </div>
    </div>
  </div>

  <div class="radius-10 p-20">
    <div class="flex gap-30 mb-20 align-items-center">
      <div class="flex gap-10 align-items-center content-center" style="flex-shrink: 0; white-space: nowrap;">
        <img src="assets/silhouettes-light-blue.svg" alt="people">
        <p class="light-blue bold no-margin">
          {{(president ? 1 : 0) + selectedAssessors.length}} membre(s) sélectionné(s)
        </p>
      </div>

      <div class="flex gap-10 align-items-center content-center">
        <span class="exclamation">!</span>
        <p class="grey no-margin">
          Le bureau de vote supervise le bon déroulement du scrutin électronique et participe aux opérations de
          scellement, d'ouverture et de clôture du scrutin. Les membres doivent être sélectionnés parmi la liste
          électorale.
          <span class="bold">Un électeur candidat ne peut pas être membre du bureau de vote.</span>
        </p>
      </div>
    </div>

    <div class="p-20 mb-20 bg-pastel-yellow radius-10 border-yellow flex gap-10 align-items-center">
      <img src="assets/warning-icon.svg" alt="warning">
      <p class="brown">
        Le bureau de vote doit contenir au minimum <span class="bold">1 président et 2 assesseurs</span>.
      </p>
    </div>

    <div class="mb-20 flex gap-20 align-items-start">

      <div class="radius-10 border-gray" style="flex: 1;">
        <div class="bg-pastel-blue p-20" style="border-radius: 10px 10px 0 0;">
          <p class="dark-blue bold no-margin">Président du bureau de vote <span class="red">*</span></p>
        </div>
        <div class="p-20">
          <!-- Président sélectionné -->
          <div *ngIf="president" class="mb-10">
            <div class="flex content-between align-items-center mb-10 p-10 radius-5"
              style="border: solid 1px #E8E8E8; background: #FAFAFA;">
              <div class="flex gap-10 align-items-center">
                <p class="no-margin">{{president.firstName}} {{president.lastName}}</p>
                <p class="no-margin small-text gray">{{president.email}}</p>
              </div>
              <div class="flex gap-10 align-items-center">
                <img *ngIf="!isValidated" (click)="removePresident()" src="assets/close_24px.svg" alt=""
                  class="pointer">
              </div>
            </div>
          </div>

          <!-- Bouton pour ajouter le président -->
          <button *ngIf="!president && !showPresidentSearch && !isValidated"
            class="flex gap-10 align-items-center content-center p-20 radius-10 pointer w-full bg-white light-blue"
            style="border: dashed 1px #1990FF;" (click)="addPresident()">
            <span class="bold">+</span> Ajouter le président
          </button>

          <!-- Zone de recherche président -->
          <div *ngIf="showPresidentSearch && !president">
            <div class="w-full border-box flex gap-10 align-items-center mb-10">
              <input type="text" [(ngModel)]="presidentSearchTerm" class="w-full p-10 radius-10 border-box"
                style="border: solid 1px #1990FF;" placeholder="Rechercher le président..." />
              <img src="assets/close_24px.svg" alt="close" class="pointer"
                (click)="showPresidentSearch = false; presidentSearchTerm = ''">
            </div>

            <div class="mt-10" style="max-height: 300px; overflow-y: auto;">
              <div *ngFor="let candidate of getFilteredCandidatesForPresident()" class="p-10 pointer radius-5 mb-5"
                style="border: solid 1px #E8E8E8; background: #FAFAFA;" (click)="selectPresident(candidate)">
                <p class="no-margin bold">{{candidate.firstName}} {{candidate.lastName}}</p>
                <p class="no-margin small-text gray">{{candidate.email}}</p>
              </div>
              <div *ngIf="getFilteredCandidatesForPresident().length === 0" class="p-10 text-center gray">
                <p class="no-margin">Aucun candidat trouvé</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="radius-10 border-gray" style="flex: 1;">
        <div class="bg-pastel-blue p-20" style="border-radius: 10px 10px 0 0;">
          <p class="dark-blue bold no-margin">Assesseurs (2 à 5) <span class="red">*</span>
          </p>
        </div>
        <div class="p-20">
          <!-- Liste des assesseurs sélectionnés -->
          <div *ngIf="selectedAssessors.length > 0" class="mb-10">
            <div *ngFor="let assessor of selectedAssessors"
              class="flex content-between align-items-center mb-10 p-10 radius-5"
              style="border: solid 1px #E8E8E8; background: #FAFAFA;">
              <div class="flex gap-10 align-items-center">
                <p class="no-margin">{{assessor.firstName}} {{assessor.lastName}}</p>
                <p class="no-margin small-text gray">{{assessor.email}}</p>
              </div>
              <div class="flex gap-10 align-items-center">
                <img *ngIf="!isValidated" (click)="removeAssessor(assessor)" src="assets/close_24px.svg" alt=""
                  class="pointer">
              </div>
            </div>
          </div>

          <!-- Bouton pour ajouter un assesseur -->
          <button *ngIf="!showAssessorSearch && !isValidated && selectedAssessors.length < 5"
            class="flex gap-10 align-items-center content-center p-20 radius-10 pointer w-full bg-white light-blue"
            style="border: dashed 1px #1990FF;" (click)="addAssessor()">
            <span class="bold">+</span> Ajouter un assesseur
          </button>

          <!-- Zone de recherche assesseur -->
          <div *ngIf="showAssessorSearch">
            <div class="w-full border-box flex gap-10 align-items-center mb-10">
              <input type="text" [(ngModel)]="assessorSearchTerm" class="w-full p-10 radius-10 border-box"
                style="border: solid 1px #1990FF;" placeholder="Rechercher un assesseur..." />
              <img src="assets/close_24px.svg" alt="close" class="pointer"
                (click)="showAssessorSearch = false; assessorSearchTerm = ''">
            </div>

            <div class="mt-10" style="max-height: 300px; overflow-y: auto;">
              <div *ngFor="let candidate of getFilteredCandidatesForAssessors()" class="p-10 pointer radius-5 mb-5"
                style="border: solid 1px #E8E8E8; background: #FAFAFA;" (click)="selectAssessor(candidate)">
                <p class="no-margin bold">{{candidate.firstName}} {{candidate.lastName}}</p>
                <p class="no-margin small-text gray">{{candidate.email}}</p>
              </div>
              <div *ngIf="getFilteredCandidatesForAssessors().length === 0" class="p-10 text-center gray">
                <p class="no-margin">Aucun candidat trouvé</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <button *ngIf="!isValidated" class="bg-dark-blue w-full p-20 white bold radius-10 no-border"
      [disabled]="!canValidate()" [style.opacity]="canValidate() ? '1' : '0.5'"
      [style.cursor]="canValidate() ? 'pointer' : 'not-allowed'" (click)="canValidate() && validateAssessors()">
      Valider les assesseurs
    </button>
  </div>
</div>